import React from 'react'
import Divider from '../../Divider'
import NoPadH3 from '../../titles/NoPadH3'
import { Button } from 'react-bootstrap'
 
const Inactive = () => {

  const goals = [
    {id:1, name: "Discount 01", discountAmount:"20%", target: "All", targetAmount:"More than 1000 $", activationStarts:"22-03-2021", desc: "Minim esse officia laborum veniam minim mollit.", createdAt:"12-02-2021", activeUntil: "21-05-2022", reached: false},
    {id:2, name: "Discount 02", discountAmount:"20%", target: "All", targetAmount:"More than 1000 $", activationStarts:"22-03-2021", desc: "Minim esse officia laborum veniam minim mollit.", createdAt:"12-02-2021", activeUntil: "21-05-2022", reached: false},
    {id:3, name: "Discount 03", discountAmount:"20%", target: "All", targetAmount:"More than 1000 $", activationStarts:"22-03-2021", desc: "Minim esse officia laborum veniam minim mollit.", createdAt:"12-02-2021", activeUntil: "21-05-2022", reached: false},
    {id:4, name: "Discount 04", discountAmount:"20%", target: "All", targetAmount:"More than 1000 $", activationStarts:"22-03-2021", desc: "Minim esse officia laborum veniam minim mollit.", createdAt:"12-02-2021", activeUntil: "21-05-2022", reached: false},
    {id:5, name: "Discount 05", discountAmount:"20%", target: "All", targetAmount:"More than 1000 $", activationStarts:"22-03-2021", desc: "Minim esse officia laborum veniam minim mollit.", createdAt:"12-02-2021", activeUntil: "21-05-2022", reached: false},
    {id:6, name: "Discount 06", discountAmount:"20%", target: "All", targetAmount:"More than 1000 $", activationStarts:"22-03-2021", desc: "Minim esse officia laborum veniam minim mollit.", createdAt:"12-02-2021", activeUntil: "21-05-2022", reached: false},
    {id:7, name: "Discount 07", discountAmount:"20%", target: "All", targetAmount:"More than 1000 $", activationStarts:"22-03-2021", desc: "Minim esse officia laborum veniam minim mollit.", createdAt:"12-02-2021", activeUntil: "21-05-2022", reached: false},
  ]

  return (<>
    <NoPadH3>Inactive</NoPadH3>
    <Divider />
    <div className='d-flex flex-wrap p-2'>
      {goals.map(g => <div key={g.id} style={{maxWidth:"240px"}} className='p-4 m-2 rounded shadow shadow-danger'>
        <p className='fs-3'>{g.name}</p>
        <p>{g.desc}</p>
        <div className='d-flex justify-content-between '>
          <p>Amount:</p>
          <p>{g.discountAmount}</p>
        </div>
        <div className='d-flex justify-content-between'>
          <p>Target:</p>
          <p>{g.target}</p>
        </div>
        <div className='d-flex justify-content-between'>
          <p>Target Amount:</p>
          <p className='text-end'>{g.targetAmount}</p>
        </div>
        <div style={{padding:"0.1px", background:"lightgray"}}></div>
        <div className='mt-3 d-flex justify-content-between'> 
          <p className=''>Created:</p>
          <p>{g.createdAt}</p>
        </div>
        <div className='d-flex justify-content-between'> 
          <p className=''>Activation:</p>
          <p>{g.activationStarts}</p>
        </div>
        <div className='d-flex justify-content-between'>
          <p>Deactivated:</p>
          <p>{g.activeUntil}</p>
        </div>
        <Button variant='outline-warning' className='w-100'>Edit</Button>
        <Button className='w-100 mt-3' variant='outline-info'>Deactivate</Button>
        <Button className='w-100 mt-3' variant='outline-danger'>Remove</Button>
      </div>)}
    </div>
  </>)
}

export default Inactive